import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <div className="privacy-header-container">
          <Link to="/" className="back-link" onClick={scrollToTop}>
            ← Back to Home
          </Link>
        </div>
      </header>

      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-update">Last Updated: February 8, 2026</p>

        <section className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to TrustPoweredAI. We are committed to protecting your privacy and handling your data in an open and transparent manner. This Privacy Policy explains how we collect, use, and protect your personal information when you sign up to receive updates about our AI compliance framework.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Information We Collect</h2>
          <p>
            We collect minimal information from you:
          </p>
          <ul>
            <li><strong>Email Address:</strong> When you sign up for updates, we collect your email address. This is the only personal information we collect.</li>
            <li><strong>Timestamp:</strong> We record the date and time when you signed up.</li>
          </ul>
          <p>
            We do not collect any other personal information such as your name, address, phone number, or payment information.
          </p>
        </section>

        <section className="privacy-section">
          <h2>3. How We Use Your Information</h2>
          <p>
            We use your email address solely for the following purposes:
          </p>
          <ul>
            <li>To send you updates about our AI compliance framework and methodology</li>
            <li>To share educational content about AI compliance best practices</li>
            <li>To notify you when we launch new resources or services related to AI compliance</li>
          </ul>
          <p>
            We will never spam you with irrelevant content or excessive emails.
          </p>
        </section>

        <section className="privacy-section">
          <h2>4. Data Protection & Security</h2>
          <p>
            We take the security of your data seriously:
          </p>
          <ul>
            <li>Your email address is stored securely on our server</li>
            <li>We use industry-standard security measures to protect your data</li>
            <li>Access to your information is restricted to authorized personnel only</li>
            <li>We regularly review and update our security practices</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>5. No Third-Party Sharing</h2>
          <p>
            <strong>We do not sell, trade, or share your email address with any third parties.</strong> Your information stays with us and is used only for the purposes described in this policy.
          </p>
          <p>
            The only exception would be if required by law or to protect our legal rights, but we will make every effort to notify you first if legally permitted.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Your Rights</h2>
          <p>
            You have the following rights regarding your personal data:
          </p>
          <ul>
            <li><strong>Right to Access:</strong> You can request a copy of the data we hold about you</li>
            <li><strong>Right to Deletion:</strong> You can request that we delete your email address from our system at any time</li>
            <li><strong>Right to Unsubscribe:</strong> You can unsubscribe from our emails at any time by clicking the unsubscribe link in any email we send you</li>
            <li><strong>Right to Object:</strong> You can object to our processing of your data</li>
          </ul>
          <p>
            To exercise any of these rights, please contact us using the information provided below.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Data Retention</h2>
          <p>
            We will retain your email address until you request deletion or unsubscribe from our mailing list. Upon receiving such a request, we will promptly remove your information from our active database.
          </p>
        </section>

        <section className="privacy-section">
          <h2>8. Compliance</h2>
          <p>
            This Privacy Policy is designed to comply with:
          </p>
          <ul>
            <li>General Data Protection Regulation (GDPR)</li>
            <li>California Consumer Privacy Act (CCPA)</li>
            <li>Other applicable privacy laws and regulations</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>9. Contact Information</h2>
          <p>
            If you have any questions, concerns, or requests regarding this Privacy Policy or your personal data, please contact us at:
          </p>
          <div className="contact-info">
            <p><strong>Email:</strong> privacy@trustpoweredai.com</p>
            <p><strong>Website:</strong> https://trustpoweredai.com</p>
          </div>
        </section>

        <section className="privacy-section">
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in our practices or for legal reasons. When we make changes, we will update the "Last Updated" date at the top of this policy.
          </p>
          <p>
            We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.
          </p>
        </section>

        <div className="privacy-footer">
          <Link to="/" className="back-button" onClick={scrollToTop}>
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
